import { StoryListParams, ParamsStoryForForm, ParamMassStorySort, Story } from 'types/story';
import { createAppAsyncThunk } from 'utils/createAppAsyncThunk';
import { startLoading, hasError } from '../slices/story';
import { dispatch } from '../store';
import { ApiClients } from '../../utils/axios';

const { axiosApp } = ApiClients;

export const getStoryListThunk = createAppAsyncThunk(
  'story/getStoryListThunk',
  async (params: StoryListParams, { rejectWithValue, extra }) => {
    try {
      return (await extra.api.getStoryList(params)).data;
    } catch (error: unknown) {
      //TODO: добавить обработку ошибок
      return rejectWithValue('ошибка загрузки списка сторис');
    }
  }
);

export const getStoryThunk = createAppAsyncThunk(
  'story/getStoryThunk',
  async (id: number, { rejectWithValue, extra }) => {
    try {
      return (await extra.api.getStory(id)).data.data;
    } catch (error: unknown) {
      //TODO: добавить обработку ошибок
      return rejectWithValue('ошибка загрузки сторис');
    }
  }
);

export const editStoryThunk = createAppAsyncThunk(
  'story/editStoryThunk',
  async (params: Story, { rejectWithValue, extra }) => {
    try {
      return (await extra.api.editStory(params)).data.data;
    } catch (error: unknown) {
      //TODO: добавить обработку ошибок
      return rejectWithValue('ошибка обновления сторис');
    }
  }
);

export const createStoryThunk = createAppAsyncThunk(
  'story/createStoryThunk',
  async (params: ParamsStoryForForm, { rejectWithValue, extra }) => {
    try {
      return (await extra.api.createStory(params)).data.data;
    } catch (error: unknown) {
      //TODO: добавить обработку ошибок
      return rejectWithValue('ошибка обновления сторис');
    }
  }
);

export function deleteStoryThunk(id: number) {
  return async () => {
    dispatch(startLoading());
    try {
      await axiosApp.delete(`stories/${id}`);

      dispatch(getStoryListThunk({}));
    } catch (error) {
      dispatch(hasError(error));
    }
  };
}

export function setMassSortStoryThunk(params: ParamMassStorySort[]) {
  return async () => {
    dispatch(startLoading());
    try {
      await axiosApp.post('stories/sort', {
        stories: params,
      });

      return true;
    } catch (error) {
      dispatch(hasError(error));
    }
  };
}
